exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multiText{font-size:10px;font-family:sans-serif}.ListParent{padding-left:40px;display:grid;grid-template-columns:repeat(5, auto)}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/d3Components/MultiLineChart/legend.scss
// module id = 903
// module chunks = 0